import Click from './click'
import Exposure from './exposure'

// 实例化曝光和点击
const exp = new Exposure()
const cli = new Click()

const trackDirective = {
  mounted(el, binding) {
    // 获取指令参数
    const { arg, value, instance } = binding
    // 如果值为isNOTReport，则不进行埋点上报,目前是针对优惠券领取按钮的特殊处理
    if (value === 'isNOTReport') {
      return
    }
    // 处理 trace-key 支持对象写法
    let traceKeyObj = null
    if (el.hasAttribute && el.hasAttribute('trace-key')) {
      try {
        // 尝试解析 trace-key 属性为对象
        const raw = el.getAttribute('trace-key')
        if (raw && (raw.trim().startsWith('{') || raw.trim().startsWith('['))) {
          traceKeyObj = JSON.parse(raw)
        }
      } catch (e) {
        traceKeyObj = null
      }
    }
    if (arg) {
      arg.split('|').forEach(item => {
        // 处理 trace-key
        let eventTraceKey = null
        if (traceKeyObj && typeof traceKeyObj === 'object') {
          eventTraceKey = traceKeyObj[item]
        } else if (el.hasAttribute && el.hasAttribute('trace-key')) {
          eventTraceKey = el.getAttribute('trace-key')
        }
        // 设置到 dom 属性，供 click/exposure 取用
        if (eventTraceKey) {
          el.setAttribute(`trace-key-${item}`, eventTraceKey)
        }
        // 点击
        if (item === 'click') {
          cli.add({ el })
        } else if (item === 'exposure') {
          exp.add({ el })
        }
      })
    }
  },
  unmounted(el) {
    // 清理事件监听器等
    cli.remove && cli.remove({ el })
    exp.remove && exp.remove({ el })
  },
}

// 点击埋点示例
// v-track:click
// trace-key="itinerary_share"
// :track-params="JSON.stringify({
//   share_platform: item.share_platform
// })"

// 曝光埋点示例
// v-track:exposure
// trace-key="itinerary_detail_click"
// :track-params="JSON.stringify({
//   form: 0
// })"

// 同时曝光点击
// v-track:exposure|click
// trace-key="itinerary_detail_click"
// :track-params="JSON.stringify({
//   form: 0
// })"

export default trackDirective
